import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetExampleAudioV2Response } from './get-example-audio-v2-response';
import { getExampleAudioV2ResponseSchema } from './get-example-audio-v2-response';

export async function getExampleAudioV2Api(
  slug: string,
  exampleId: number,
): Promise<IValidatedResponse<IGetExampleAudioV2Response>> {
  return getRequest<IGetExampleAudioV2Response>({
    path: `/challenges/${slug}/audio/v2/example/${exampleId}`,
    schema: getExampleAudioV2ResponseSchema,
  });
}
